(() => {
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cookie-preferences]');
    if (!trigger) return;

    const showPreferences = window.Shopify?.customerPrivacy?.showPreferences;
    if (typeof showPreferences !== 'function') return;

    event.preventDefault();
    showPreferences();
  });
})();
